import { render, staticRenderFns } from "./ruleLeft.vue?vue&type=template&id=38935b5c&scoped=true"
import script from "./ruleLeft.vue?vue&type=script&lang=js"
export * from "./ruleLeft.vue?vue&type=script&lang=js"
import style0 from "./ruleLeft.vue?vue&type=style&index=0&id=38935b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38935b5c",
  null
  
)

export default component.exports